export const FILTER_NAME = 'cross-shipment'
